// extracted by mini-css-extract-plugin
export default {"header":"Account_header__BtAY4","btn":"Account_btn__D2piP","title":"Account_title__BFfW6","content":"Account_content__bDnG-"};